// French strings of the agent drawer (registered at module load; the shell dictionary already holds
// agentdrawer.tabs.*, agentdrawer.toTask, agentStatus.* and engine.*).
import { registerStrings } from '../../i18n/fr.js';

registerStrings({
  // Frame
  'ad.eyebrow': '{dept} · {floor}',
  'ad.notFound.title': 'Agent introuvable',
  'ad.notFound.text': 'Cet agent n’existe plus, ou il ne fait pas partie de vos accès.',
  'ad.tabsLabel': 'Sections de la fiche agent',
  'ad.lead': 'Responsable du service',
  'ad.gear': 'Réglages de {name}',

  'ad.currentTask': 'Tâche en cours : {title}',
  'ad.waitingTask': 'À valider : {title}',
  'ad.currentTaskAria': 'Ouvrir la tâche en cours : {title}',
  'ad.activity': 'utilise {tool}',
  'ad.activity.web': 'cherche sur le web',
  'ad.activity.fetch': 'lit une page web',
  'ad.activity.files': 'travaille sur des fichiers',
  'ad.activity.waiting': 'en attente de {name}',
  'ad.activity.library': 'utilise un connecteur du bureau',
  'ad.autonomy.approve': 'Je valide avant d’agir',
  'ad.autonomy.auto': 'Agit seul',
  'ad.autonomy.switch': 'Je valide avant d’agir',
  'ad.avatarLabel': 'Avatar de {name}',

  // Discussion
  'ad.chat.intro': 'Discussion privée avec {name} ({engine}). Ici, l’agent répond et réfléchit avec vous : il consulte ses outils mais n’envoie ni ne modifie rien. Pour qu’il travaille vraiment, lancez une tâche.',
  'ad.chat.launch': 'Lancer comme tâche',
  'ad.chat.workHint': 'Pour qu’il s’y mette vraiment (outils, brouillon à valider) : lancez une tâche.',
  'ad.chat.launchTitle': 'Confier ce texte à {name} comme une tâche (avec ses outils, puis votre validation)',
  'ad.chat.launchEmpty': 'Écrivez d’abord ce que l’agent doit faire, puis « Lancer comme tâche ».',
  'ad.chat.clear': 'Effacer',
  'ad.chat.clearAria': 'Effacer la discussion',
  'ad.chat.clearTitle': 'Effacer la discussion ?',
  'ad.chat.clearText': 'Tous les messages échangés avec {name} sont supprimés.',
  'ad.chat.clearOk': 'EFFACER',
  'ad.chat.cleared': 'Discussion effacée.',
  'ad.chat.loading': 'Chargement de la discussion…',
  'ad.chat.empty.title': 'Discutez avec {name}',
  'ad.chat.empty.text': 'Posez une question, demandez un avis ou un plan. Pour faire agir l’agent, transformez un message en tâche.',
  'ad.chat.unavailable': 'La discussion n’est pas encore disponible sur ce serveur.',
  'ad.chat.forbidden': 'Vous pouvez consulter cet agent, mais pas discuter avec lui.',
  'ad.chat.placeholder': 'Écrire à {name}…',
  'ad.chat.inputLabel': 'Message à {name}',
  'ad.chat.send': 'Envoyer',
  'ad.chat.hint': 'Entrée pour envoyer · Maj+Entrée pour aller à la ligne · 📎 ou collez jusqu’à 2 images',
  'ad.chat.openImage': 'Agrandir l’image {name}',
  'ad.chat.typing': '{name} écrit…',
  'ad.chat.busy': 'Une réponse est déjà en cours pour cet agent. Patientez un instant.',
  'ad.chat.failed': 'Message non envoyé : {error}',
  'ad.chat.noReply': '{name} n’a pas pu répondre. Réessayez dans un instant.',
  'ad.chat.tooLong': 'Message trop long ({max} caractères au plus).',
  'ad.chat.you': 'Vous',
  'ad.chat.logLabel': 'Messages de la discussion',
  'ad.chat.taskLink': 'Tâche créée',
  'ad.chat.count': '{n} / {max}',

  // Transformer en tâche
  'ad.toTask.title': 'Transformer en tâche',
  'ad.toTask.label': 'Demande confiée à {name}',
  'ad.toTask.hint': 'Relisez et précisez la demande : l’agent la traitera comme une tâche, avec ses outils.',
  'ad.toTask.approve': 'Je valide avant d’agir',
  'ad.toTask.approveHint': 'L’agent prépare un brouillon ; rien ne part sans votre accord.',
  'ad.toTask.autoHint': 'L’agent agit seul avec ses outils et termine la tâche.',
  'ad.toTask.autoLocked': 'Cet agent valide toujours avant d’agir (réglage d’un responsable).',
  'ad.toTask.submit': 'LANCER',
  'ad.toTask.created': 'Tâche créée pour {name}.',
  'ad.toTask.fromAgent': '{question}\n\nRéponse de l’agent à reprendre :\n{answer}',
  'ad.toTask.onMessage': 'Transformer ce message en tâche',
  'ad.toTask.required': 'Décrivez la tâche.',
  'ad.toTask.tooLong': 'Demande trop longue ({max} caractères au plus).',
  'ad.toTask.open': 'Ouvrir',
  'ad.toTask.images': 'Images jointes',
  'ad.toTask.imagesHint': 'Elles partent avec la tâche : l’agent les retrouve dans « Fichiers fournis ».',
  'ad.toTask.removeImage': 'Ne pas joindre {name}',

  // Aperçu
  'ad.ov.noDoes': 'Aucune description : un responsable peut l’écrire dans Réglages.',
  'ad.ov.chat': 'Discuter',
  'ad.ov.autonomy': 'VALIDATION',
  'ad.ov.autonomyReadOnly': 'Seul un responsable du service peut changer ce réglage.',
  'ad.ov.autonomySavedApprove': '{name} vous demandera de valider avant d’agir.',
  'ad.ov.autonomySavedAuto': '{name} agit seul désormais.',
  'ad.ov.connectors': 'CONNECTEURS',
  'ad.ov.noConnectors': 'Aucun connecteur : l’agent travaille sans outils extérieurs.',
  'ad.ov.connDown': 'non connecté',
  'ad.ov.connMissing': 'introuvable',
  'ad.ov.connDenied': 'pas pour vos demandes',
  'ad.ov.connDeniedTitle': 'Ce connecteur n’est pas dans vos connecteurs autorisés : l’agent travaille sans lui pour vos demandes. Il reste disponible pour les personnes autorisées.',
  'ad.ov.editConnectors': 'Modifier les connecteurs',
  'ad.ov.routines': 'PROCHAINES ROUTINES',
  'ad.ov.newRoutine': 'Nouvelle routine',
  'ad.ov.allRoutines': 'Toutes ses routines',
  'ad.ov.allRoutinesN': { one: 'Sa routine', other: 'Toutes ses routines ({n})' },
  'ad.ov.tasks': 'DERNIÈRES TÂCHES',
  'ad.ov.noTasks': 'Aucune tâche confiée à {name} pour le moment.',
  'ad.ov.allTasks': 'Toutes ses tâches',

  // Routines
  'ad.rt.intro': 'Ce que {name} fait seul, à heure fixe. En pause, une routine reste au planning sans se lancer.',

  // Tâches
  'ad.tasks.loading': 'Chargement des tâches…',
  'ad.tasks.empty.title': 'Aucune tâche',
  'ad.tasks.empty.text': 'Les tâches confiées à {name} apparaîtront ici.',
  'ad.tasks.emptyFilter': 'Aucune tâche ne correspond à ce filtre.',
  'ad.tasks.unavailable': 'La liste des tâches n’est pas encore disponible sur ce serveur : seules les tâches déjà connues du navigateur sont affichées.',
  'ad.tasks.listLabel': 'Tâches de {name}',
  'ad.tasks.open': 'Ouvrir : {title}',

  // Réglages — sections
  'ad.set.identity': 'IDENTITÉ',
  'ad.set.brief': 'CONSIGNES',
  'ad.set.engine': 'MOTEUR',
  'ad.set.autonomy': 'AUTONOMIE & ACCÈS',
  'ad.set.connectors': 'CONNECTEURS',
  'ad.set.lessons': 'RÈGLES APPRISES',
  'ad.set.advanced': 'AVANCÉ',
  'ad.set.danger': 'ZONE SENSIBLE',

  // Réglages — fields
  'ad.f.name': 'Nom (sur le bureau)',
  'ad.f.nameHint': 'En majuscules, 22 caractères au plus.',
  'ad.f.role': 'Rôle',
  'ad.f.roleHint': 'Une ligne, ex. « Rédacteur des réponses clients ».',
  'ad.f.does': 'Ce que fait l’agent',
  'ad.f.doesHint': 'Lu par l’agent avant chaque tâche et utilisé pour choisir le bon agent d’un service.',
  'ad.f.brief': 'Consignes permanentes',
  'ad.f.briefHint': 'Ton, format, règles à suivre toujours. Lues avant chaque tâche et chaque discussion.',
  'ad.f.briefPlaceholder': 'Ex. : Réponses courtes. Tutoiement. Jamais de promesse de délai sans vérifier la commande.',
  'ad.f.count': '{n} / {max}',
  'ad.f.engine': 'Moteur',
  'ad.f.engineClaude': 'Claude',
  'ad.f.engineCodex': 'Codex (ChatGPT)',
  'ad.f.engineImages': 'Images OpenAI',
  'ad.f.engineGemini': 'Gemini',
  'ad.f.engineKie': 'Kie.ai (vidéo)',
  'ad.f.engineHelp.kie': 'Crée une vidéo par tâche avec Kie.ai (clé API dans Administration → Moteurs, facturée en crédits Kie.ai). Le modèle choisit l’usage : Seedance 2.0 par défaut ou MiniMax H3 (image de départ, ou « Mode : références » : produit, mouvement, son), Kling 3.0 ou Wan Animate (transfert de mouvement), InfiniTalk (avatar qui parle), Topaz (agrandir). Les fichiers joints à la tâche sont envoyés selon le modèle ; la demande sert de description (en anglais de préférence). Options : « Durée : 8 s », « Format : 9:16 », « Résolution : 720p », « Audio : non », « Modèle : … ». Suno V6 (suno/v6) crée une musique (2 pistes MP3 en général), sans fichier joint ; la demande décrit l’ambiance, options « Style : … », « Titre : … », « Durée : 30 s » (10 s à 6 min), « Instrumental : non » (la demande donne alors les paroles), « À éviter : … ». Pas de connecteurs.',
  'ad.conn.noEngineKie': 'Le moteur Kie.ai (vidéo) n’utilise ni connecteurs ni web : il crée la vidéo à partir des fichiers joints et de la description.',
  'ad.f.modelPlaceholderKie': 'par défaut : bytedance/seedance-2',
  'ad.f.engineHelp.gemini': 'Analyse de vidéos et d’images ; pas d’outils. Gemini (Google) reçoit le texte de la tâche et ses fichiers (vidéo, images, PDF, audio) et répond en texte ou en JSON, sans connecteur ni web : parfait pour analyser une pub vidéo ou contrôler une séquence. Clé GEMINI_API_KEY dans config/.env (mode API), sinon le CLI gemini.',
  'ad.f.effortHintGemini': 'Niveau de réflexion de Gemini (faible, moyen, élevé). Plus d’effort : plus lent, plus soigné.',
  'ad.conn.noEngineGemini': 'Le moteur Gemini n’utilise ni connecteurs ni web : il analyse le texte et les fichiers qu’on lui donne.',
  'ad.engineBadge': 'Moteur : {engine}',
  'ad.f.engineHelp.claude': 'Claude Code sur votre abonnement Claude, avec les connecteurs (Gmail, ClickUp, Drive…). Le bon choix pour rédiger, chercher et agir.',
  'ad.f.engineHelp.codex': 'Codex sur votre abonnement ChatGPT. Utile pour créer des images avec l’outil intégré (sans terminal : aucune commande sur le Mac mini).',
  'ad.f.engineHelp.openai-image': 'Génère une image par tâche avec l’API OpenAI (clé API nécessaire, facturée à l’usage). La demande sert de description de l’image ; pas de connecteurs.',
  'ad.f.engineDown': 'Ce moteur n’est pas disponible pour le moment{error}.',
  'ad.f.engineOff': 'Ce moteur n’est pas connecté : un administrateur doit le connecter (Administration → Moteurs).',
  'ad.f.engineDisabled': 'Ce moteur est désactivé dans la configuration du bureau : les tâches de cet agent échoueront.',
  'ad.f.model': 'Modèle',
  'ad.f.modelHint': 'Laissez vide pour le modèle par défaut du moteur.',
  'ad.f.modelPlaceholder': 'par défaut',
  'ad.f.effort': 'Effort de réflexion',
  'ad.f.effortHint': 'Claude seulement. Plus d’effort : plus lent, plus soigné.',
  'ad.f.timeout': 'Durée maximale d’un travail',
  'ad.f.timeoutUnit': 'minutes',
  'ad.f.timeoutPlaceholder': 'Celle du moteur',
  'ad.f.timeoutHint': 'De 5 à 180 minutes. Vide : la durée prévue pour son moteur. Utile à un agent qui attend le travail de ses collègues.',
  'ad.v.timeout': 'Un nombre entier de minutes, de 5 à 180 (ou vide).',
  'ad.f.effortDefault': 'Par défaut',
  'ad.f.effort.low': 'Faible',
  'ad.f.effort.medium': 'Moyen',
  'ad.f.effort.high': 'Élevé',
  'ad.f.effort.xhigh': 'Très élevé',
  'ad.f.effort.max': 'Maximum',
  'ad.f.autonomy': 'Autonomie',
  'ad.f.autonomyApprove': 'Je valide avant d’agir',
  'ad.f.autonomyAuto': 'Agit seul',
  'ad.f.autonomyHint.approve': 'L’agent prépare un brouillon ; rien n’est envoyé, publié ni modifié sans votre accord.',
  'ad.f.autonomyHint.auto': 'L’agent agit seul avec ses outils en écriture. Réservez-le aux tâches sans risque.',
  'ad.f.web': 'Accès au web',
  'ad.f.webHint': 'Recherche web ; lecture de pages seulement quand l’agent exécute (pas dans les brouillons ni les discussions).',
  'ad.f.files': 'Peut créer des fichiers',
  'ad.f.filesHint': 'Images et documents dans son dossier de travail, joints au résultat.',

  // Connectors
  'ad.conn.intro': 'Les connecteurs autorisés sur l’étage « {floor} », et ceux ajoutés dans le bureau (tous les étages). En lecture, l’agent consulte ; en écriture, il peut aussi envoyer ou modifier (après validation, sauf s’il est autonome).',
  'ad.conn.everyFloor': 'TOUS LES ÉTAGES',
  'ad.conn.everyFloorTitle': 'Ajouté dans le bureau (bibliothèque de connecteurs) : disponible sur tous les étages, pour les agents Claude et Codex.',
  'ad.conn.library': 'Ajouté dans le bureau',
  'ad.conn.libraryBy': 'Ajouté par {name}',
  'ad.conn.none': 'Aucun',
  'ad.conn.read': 'Lecture',
  'ad.conn.write': 'Écriture',
  'ad.conn.accessLabel': 'Accès de l’agent à {name}',
  'ad.conn.tools': '{read} en lecture · {write} en écriture',
  'ad.conn.suggested': 'SUGGÉRÉ',
  'ad.conn.suggestedTitle': 'Cet agent est prévu pour utiliser ce connecteur.',
  'ad.conn.notConnected': 'Non connecté ({status}) : l’agent ne pourra pas s’en servir tant qu’il n’est pas reconnecté.',
  'ad.conn.missing': 'Connecteur introuvable sur le Mac mini : relancez la détection dans Administration → Connecteurs.',
  'ad.conn.notAllowed': 'N’est plus autorisé sur cet étage : il sera retiré à l’enregistrement si vous choisissez « Aucun ».',
  'ad.conn.denied': 'Hors de vos connecteurs autorisés : vous pouvez le laisser tel quel, le réduire ou le retirer, mais ni l’accorder ni l’élargir. L’agent ne s’en sert jamais pour vos demandes ; il reste disponible pour les personnes autorisées.',
  'ad.conn.deniedNone': 'Hors de vos connecteurs autorisés : vous ne pouvez pas l’accorder à cet agent. Demandez à un administrateur.',
  'ad.conn.deniedBadge': 'BLOQUÉ POUR VOUS',
  'ad.chat.deniedNote': 'Pour vos demandes, {name} travaille sans : {list} (hors de vos connecteurs autorisés).',
  // The server lets the office's administrators read the discussions (OFFICE_ADMIN_CHAT_VIEW).
  'ad.chat.adminsCanRead': 'Les administrateurs du bureau peuvent lire cette discussion.',
  'ad.chat.adminsCanReadTip': 'Les messages envoyés depuis l’activation de ce réglage, en lecture seule.',
  'ad.conn.deniedTitle': 'Réglé par l’administrateur dans Utilisateurs → Connecteurs autorisés.',
  'ad.conn.engineMismatch': 'Ce connecteur n’est pas utilisé par le moteur choisi.',
  'ad.conn.builtin': 'Intégré au bureau : la mémoire partagée de l’étage et l’équipe. En lecture, l’agent consulte les tables et voit ses collègues ; en écriture, il peut aussi modifier les tables et confier un travail à un collègue de l’étage (après validation, sauf s’il est autonome).',
  'ad.conn.noEngine': 'Le moteur Images OpenAI n’utilise pas de connecteurs.',
  'ad.conn.empty': 'Aucun connecteur n’est autorisé sur cet étage, et aucun n’a été ajouté dans le bureau. Un administrateur les choisit dans Administration → Étages & services, ou en ajoute dans Administration → Connecteurs.',
  'ad.conn.toolsAll': 'Outils : tous ({n})',
  'ad.conn.toolsAllUnknown': 'Outils : tous',
  'ad.conn.toolsSome': { one: '{k} sur {n} outil', other: '{k} sur {n} outils' },
  'ad.conn.toolsPick': 'Choisir les outils',
  'ad.conn.toolsClose': 'Fermer la liste',
  'ad.conn.toolsListLabel': 'Outils de {name}',
  'ad.conn.toolsHint': 'L’agent ne charge que les outils cochés : moins d’outils, c’est un agent plus rapide et moins cher.',
  'ad.conn.toolsSearch': 'Rechercher un outil',
  'ad.conn.toolsRead': 'Lecture',
  'ad.conn.toolsWrite': 'Écriture',
  'ad.conn.toolsWriteNote': 'Utilisés seulement avec l’accès « Écriture ».',
  'ad.conn.toolsEvery': 'Tous les outils',
  'ad.conn.toolsNoneBtn': 'Aucun',
  'ad.conn.toolsLoading': 'Chargement des outils…',
  'ad.conn.toolsUnknown': 'La liste des outils de ce connecteur n’est pas encore connue : l’agent peut tous les utiliser.',
  'ad.conn.toolsNoMatch': 'Aucun outil ne correspond.',
  'ad.conn.toolsNone': 'Cochez au moins un outil pour chaque connecteur, ou choisissez « Tous les outils ».',
  'ad.conn.toolsMax': 'Choisissez {max} outils au plus par connecteur, ou « Tous les outils ».',

  // Lessons
  'ad.lessons.intro': 'Règles retenues à partir de vos refus. L’agent les relit avant chaque tâche.',
  'ad.lessons.empty': 'Aucune règle apprise pour le moment.',
  'ad.lessons.add': 'Ajouter',
  'ad.lessons.addLabel': 'Nouvelle règle',
  'ad.lessons.placeholder': 'Ex. : Toujours signer « L’équipe » et jamais de prénom.',
  'ad.lessons.delete': 'Supprimer la règle : {text}',
  'ad.lessons.added': 'Règle ajoutée.',
  'ad.lessons.deleted': 'Règle supprimée.',
  'ad.lessons.required': 'Écrivez la règle.',
  'ad.lessons.tooLong': 'Une règle tient en {max} caractères au plus.',
  'ad.lessons.tooMany': 'Pas plus de {max} règles : supprimez-en une d’abord.',
  'ad.lessons.duplicate': 'Cette règle existe déjà.',
  'ad.lessons.count': '{n} / {max}',

  // Save bar, validation
  'ad.save': 'ENREGISTRER',
  'ad.saving': 'Enregistrement…',
  'ad.discard': 'Annuler les changements',
  'ad.dirty': { one: '{n} changement non enregistré', other: '{n} changements non enregistrés' },
  'ad.clean': 'Tout est enregistré.',
  'ad.saved': 'Réglages de {name} enregistrés.',
  'ad.invalid': 'Corrigez les champs signalés avant d’enregistrer.',
  'ad.v.required': 'Ce champ est obligatoire.',
  'ad.v.tooLong': '{max} caractères au plus.',
  'ad.v.model': 'Nom de modèle invalide : lettres, chiffres et . _ - : / @ [ ] seulement.',
  'ad.changedElsewhere': 'Cet agent a été modifié ailleurs pendant que vous le régliez : vos changements sont conservés.',

  // Delete agent
  'ad.delete': 'SUPPRIMER L’AGENT',
  'ad.deleteHint': 'Supprime l’agent de son service. Ses tâches passées restent consultables.',
  'ad.deleteTitle': 'Supprimer {name} ?',
  'ad.deleteText': 'L’agent disparaît du bureau. Cette action est définitive. Elle est refusée tant qu’une routine, un déclencheur ou une tâche en cours l’utilise : réaffectez-les d’abord.',
  'ad.deleteOk': 'SUPPRIMER',
  'ad.deleted': '{name} a été supprimé.',

  // Extra
  'ad.status.label': 'Statut',
  'ad.status.since': 'depuis {duration}',
  'ad.settings.loading': 'Chargement des réglages…',
  'ad.settings.forbidden': 'Il faut être responsable du service pour régler cet agent.',
  'ad.conn.suggestions': 'Suggestions :',
  'ad.model.suggestions': 'Modèles courants',
  'ad.model.useSuggestion': 'Utiliser le modèle {model}',
  'ad.general': 'À corriger',
  'ad.chat.retry': 'Réessayer',
  'ad.chat.at': '{when}',
  'ad.tasks.more': 'Voir plus',
  'ad.unsaved.title': 'Quitter sans enregistrer ?',
  'ad.unsaved.text': 'Les changements des réglages seront perdus.',
  'ad.unsaved.ok': 'QUITTER',
  'ad.unsaved.keep': 'Rester',
});
